module.exports = __webpack_public_path__ + "9ce4a65cc5077024ed1278e6d2d1b8a6.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/tiers/wing-10.png
// module id = 3676
// module chunks = 0